import React, { PureComponent, useCallback, useEffect, useRef } from 'react'
import { v4 as uuid } from 'uuid'
import { useTranslation } from 'react-i18next'
import DatePicker from '@ublique/components/DatePicker'
// import { datePickerLocales } from '../../../../helpers'
import './index.scss'

export const datePickerLocales = {
  'it-IT': 'it',
  'en-GB': 'en'
}

const DateInput = ({ id, value, onChange, container, gridApi }) => {
  const { i18n } = useTranslation('OutputView')
  const ref = useRef()

  const onScroll = useCallback(() => {
    if (ref.current) {
      ref.current.cal.close()
    }
  }, [])

  useEffect(() => {
    const content = document.querySelector('.ublique-container-template')
    const picker = ref.current

    if (picker && gridApi) {
      picker.cal.calendarContainer.classList.add('ag-custom-component-popup')
      gridApi.addEventListener('bodyScroll', onScroll)
      content.addEventListener('scroll', onScroll)
    }

    return () => {
      gridApi.removeEventListener('bodyScroll', onScroll)
      content.removeEventListener('scroll', onScroll)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <DatePicker
      ref={ref}
      key={`datePicker_lang_${i18n.language}`}
      className='grid-date-picker'
      datePickerType='single'
      dateFormat='Y/m/d'
      value={value}
      onChange={onChange}
      locale={datePickerLocales[i18n.language] || 'it'}
      appendTo={container}
    >
      <DatePicker.Input
        id={id}
        placeholder='YYYY/MM/DD'
        autoComplete='off'
        labelText='date'
        hideLabel
      />
    </DatePicker>
  )
}

class GridDate extends PureComponent {
  state = { date: null }
  elementId = uuid()

  getDate() {
    return this.state.date
  }

  setDate(date) {
    this.setState({ date })
  }

  onDateChanged = ([date]) => {
    const { onDateChanged } = this.props
    this.setState({ date }, onDateChanged)
  }

  render() {
    const { date } = this.state
    const { frameworkComponentWrapper } = this.props
    return (
      <DateInput
        id={this.elementId}
        value={date}
        onChange={this.onDateChanged}
        gridApi={frameworkComponentWrapper.agGridReact.api}
      />
    )
  }
}

export default GridDate
